import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Profile } from '@cemex-core/cmx-api/models/profiles-management/profile';
import { Store } from '@ngrx/store';
import { getSpecificationForm, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { hasDifferentToPump, hasPump } from '../../../helpers/should-hide-pump';

@Injectable()
export class DirectProjectProfilesOptionLoader implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return combineLatest([
      this.store.select(getSpecificationForm),
      hasDifferentToPump(this.store, formGroup),
      hasPump(this.store, formGroup),
    ]).pipe(
      map(([state]) => {
        return state.projectProfiles.map((profile: Profile) => {
          return {
            id: profile.profileId,
            name: profile.profileName,
          };
        });
      }),
    );
  }
}
